import { AiOutlineDelete, AiOutlineEdit, AiOutlineInfo } from 'react-icons/ai';
import { type ApiConfig } from '../../../common/types';

interface IProps {
  item: ApiConfig;
  toggleInfoModal: () => any;
  toggleEditModal: () => any;
  toggleDeleteModal: () => any;
  handleInfoItem: (item: ApiConfig) => any;
  handleEditingItem: (item: ApiConfig) => any;
  handleDeletingItem: (item: ApiConfig) => any;
}

const ListApiConfigItem: React.FC<IProps> = ({
  item,
  toggleInfoModal,
  toggleEditModal,
  toggleDeleteModal,
  handleInfoItem,
  handleEditingItem,
  handleDeletingItem
}) => {
  const infoItemHandler = (): void => {
    toggleInfoModal();
    handleInfoItem(item);
  };

  const deleteItemHandler = (): void => {
    toggleDeleteModal();
    handleDeletingItem(item);
  };

  const editItemHandler = (): void => {
    toggleEditModal();
    handleEditingItem(item);
  };

  return (
    <tr className="odd:bg-white even:bg-gray-50" key={item.id}>
      <td className="p-2 pl-8 text-sm text-gray-700">
        <div className="flex flex-col">
          <span>{item.id}</span>
        </div>
      </td>
      <td className="p-2 text-sm text-gray-700">{item.ownerEntityType}</td>
      <td className="p-2 text-sm text-gray-700">{item.ownerEntityId}</td>
      <td className="p-2 pr-9 text-sm text-gray-700 ">
        <div className="flex flex-row justify-center space-x-2">
          <button onClick={infoItemHandler} className="text-gray-50 text-sm text-center rounded-md">
            <span className="px-1 h-full">
              <AiOutlineInfo color="green" size={20} />
            </span>
          </button>
          <button onClick={editItemHandler} className="text-gray-50 text-sm text-center rounded-md">
            <span className="px-1 h-full">
              <AiOutlineEdit color="green" size={20} />
            </span>
          </button>
          <button onClick={deleteItemHandler} className="text-gray-50 text-sm text-center rounded-md">
            <span className="px-1 h-full">
              <AiOutlineDelete color="red" size={18} />
            </span>
          </button>
        </div>
      </td>
    </tr>
  );
};

export default ListApiConfigItem;
